import {Button} from "antd";
import {useTicketTemplatesQuery} from './graphql';
import React, {useContext} from "react";
import {LabelInValue} from "../../../../common/form";
import './veriflyt-ticket-template-select.style.less';
import {useVeriflytTicketTemplateSelectApi, VeriflytTicketTemplateSelectApiContext} from "./state";
import SelectPanelDrawer from "./select-panel-drawer";
import SelectPanel from "./select-panel";

export interface VeriflytTicketTemplateSelectProps {
    value?: LabelInValue,
    disabledTicketTemplateIds?: string[],
    disabledMessage?: string,
    disabled?: boolean,
    onChange?: (value: LabelInValue) => void,
    noticeAlertText?: string
}

const VeriflytTicketTemplateSingleSelect: React.FC<VeriflytTicketTemplateSelectProps> = ({
    value,
    onChange,
    disabled,
    disabledTicketTemplateIds,
    disabledMessage,
    noticeAlertText
}) => {

    const ctx = useContext(VeriflytTicketTemplateSelectApiContext);
    const controlled = !!ctx;

    const queryResult = useTicketTemplatesQuery({
        limit: 9999999
    });
    const _api = useVeriflytTicketTemplateSelectApi(
        queryResult?.data
    );

    const api = controlled ? ctx : _api;

    let drawer: React.ReactNode = null;

    function handleTicketTemplateChanged(ticketTemplateID: string, onScreenName: string){
        if (typeof onChange === 'function'){
            api.closePanel();
            onChange({
                key: ticketTemplateID,
                label: onScreenName
            });
        }
    }

    if (!controlled){
        drawer = (
            <SelectPanelDrawer
                title="Select a certification"
                visible={api.state.drawerOpen}
                onClose={api.closePanel}
                bodyStyle={{
                    padding: 0
                }}
                className="ant-drawer-flex"
                destroyOnClose
            >
                <SelectPanel
                    api={api}
                    onTicketTemplateSelected={handleTicketTemplateChanged}
                    disabledTicketTemplateIds={disabledTicketTemplateIds}
                    disabledMessage={disabledMessage}
                    noticeAlertText={noticeAlertText}
                />
            </SelectPanelDrawer>
        )
    }

    function onClicked(){
        api.openPanel(value?.key);
    }

    return (
        <>
        <Button className="ant-input" onClick={onClicked} disabled={disabled}>
            <div className="ticket-template-select">
                <span>{value?.label}</span>
                {!disabled ? (
                    <span className="ticket-template-select-change-text">
                    Change
                </span>
                ) : null}
            </div>
        </Button>
            {drawer}
        </>
    )
}

export default VeriflytTicketTemplateSingleSelect